/* eslint-disable react/jsx-filename-extension */
// eslint-disable-next-line import/prefer-default-export
export const getSourcesFromUrlMap = (urlMap) => {
  if (!urlMap) return null;
  return (
    <>
      {!urlMap.default &&
        Object.keys(urlMap).map((videoType) => (
          <source key={videoType} src={urlMap[videoType]} type={videoType} />
        ))}
      {urlMap.default && (
        <source
          key={urlMap.defaultMimeType}
          src={urlMap.default}
          type={urlMap.defaultMimeType}
        />
      )}
    </>
  );
};
